// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___14c3A","overlayModal":"style__overlayModal___1WU4F","overlayModalInner":"style__overlayModalInner___3tQXm","overlayCloseButton":"style__overlayCloseButton___1ItTf","overlayModalTitle":"style__overlayModalTitle___2Ops1","overlayModalText":"style__overlayModalText___2Hn5o","overlayModalTextBold":"style__overlayModalTextBold___ABMOl","overlayModalButtons":"style__overlayModalButtons___3ap8t","overlayModalButtonsItem":"style__overlayModalButtonsItem___2epG3","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___8ko0R","buttonActive":"style__buttonActive___1fpE4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-lang/style.css
// module id = 315
// module chunks = 0